"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AttributeVisualizationEngine_api, _AttributeVisualizationEngine_converter, _AttributeVisualizationEngine_uuidGenerator, _AttributeVisualizationEngine_viewer, _AttributeVisualizationEngine_attributes, _AttributeVisualizationEngine_defaultMaterial, _AttributeVisualizationEngine_defaultLayer, _AttributeVisualizationEngine_layers, _AttributeVisualizationEngine_overview, _AttributeVisualizationEngine_listeners;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeVisualizationEngine = void 0;
const viewer_1 = require("@shapediver/viewer");
const gl_matrix_1 = require("gl-matrix");
const tsyringe_1 = require("tsyringe");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const sdk_sdtf_primitives_1 = require("@shapediver/sdk.sdtf-primitives");
class AttributeVisualizationEngine {
    // #endregion Properties (7)
    // #region Constructors (1)
    constructor(api, viewer) {
        // #region Properties (7)
        _AttributeVisualizationEngine_api.set(this, void 0);
        _AttributeVisualizationEngine_converter.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.Converter));
        _AttributeVisualizationEngine_uuidGenerator.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.UuidGenerator));
        _AttributeVisualizationEngine_viewer.set(this, void 0);
        _AttributeVisualizationEngine_attributes.set(this, []);
        _AttributeVisualizationEngine_defaultMaterial.set(this, new viewer_1.MaterialUnlitData({ color: '#000000', opacity: 1 }));
        _AttributeVisualizationEngine_defaultLayer.set(this, {
            color: '#000000',
            opacity: 1,
            enabled: true
        });
        _AttributeVisualizationEngine_layers.set(this, {});
        _AttributeVisualizationEngine_overview.set(this, void 0);
        _AttributeVisualizationEngine_listeners.set(this, {});
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_api, api, "f");
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_viewer, viewer, "f");
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_overview, __classPrivateFieldGet(this, _AttributeVisualizationEngine_api, "f").createSDTFOverview(__classPrivateFieldGet(this, _AttributeVisualizationEngine_api, "f").sceneTree.root), "f");
        this.createLayers();
        this.constructAttributeVisualization();
        __classPrivateFieldGet(this, _AttributeVisualizationEngine_api, "f").addListener(viewer_1.EVENTTYPE.SESSION.SESSION_CUSTOMIZED, () => {
            __classPrivateFieldSet(this, _AttributeVisualizationEngine_overview, __classPrivateFieldGet(this, _AttributeVisualizationEngine_api, "f").createSDTFOverview(__classPrivateFieldGet(this, _AttributeVisualizationEngine_api, "f").sceneTree.root), "f");
            this.createLayers();
            this.constructAttributeVisualization();
            for (let l in __classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f"))
                __classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f")[l]();
        });
    }
    // #endregion Constructors (1)
    // #region Public Accessors (3)
    get defaultMaterial() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f");
    }
    get defaultLayer() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f");
    }
    get layers() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f");
    }
    get overview() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_overview, "f");
    }
    // #endregion Public Accessors (3)
    // #region Public Methods (3)
    updateAttributes(attributes) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_attributes, attributes, "f");
        this.constructAttributeVisualization();
    }
    updateDefaultLayer(layer) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_defaultLayer, layer, "f");
        this.constructAttributeVisualization();
    }
    updateDefaultMaterial(material) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_defaultMaterial, material, "f");
        this.constructAttributeVisualization();
    }
    updateLayers(layers) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_layers, layers, "f");
        this.constructAttributeVisualization();
    }
    addListener(cb) {
        const token = __classPrivateFieldGet(this, _AttributeVisualizationEngine_uuidGenerator, "f").create();
        __classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f")[token] = cb;
        return token;
    }
    removeListener(token) {
        if (!__classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f")[token])
            return false;
        delete __classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f")[token];
        return true;
    }
    // #endregion Public Methods (3)
    // #region Private Methods (2)
    constructAttributeVisualization() {
        __classPrivateFieldGet(this, _AttributeVisualizationEngine_viewer, "f").convertSDTFItemToVisualizationData = (overview, itemData) => {
            // early out if there are not attributes in this itemData
            if (!itemData || !itemData.attributes) {
                if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_attributes, "f").length === 0) {
                    // return default layer material
                    const material = new viewer_1.MaterialUnlitData({
                        opacity: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").enabled ? __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").opacity : 0,
                        color: __classPrivateFieldGet(this, _AttributeVisualizationEngine_converter, "f").toColor(__classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").color)
                    });
                    return {
                        matrix: gl_matrix_1.mat4.create(),
                        material
                    };
                }
                else {
                    // return default layer material
                    const material = new viewer_1.MaterialUnlitData({
                        opacity: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").enabled ? __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").opacity * __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f").opacity : 0,
                        color: __classPrivateFieldGet(this, _AttributeVisualizationEngine_converter, "f").toColor(__classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f").color)
                    });
                    return {
                        matrix: gl_matrix_1.mat4.create(),
                        material
                    };
                }
            }
            // search for the responsible layer property, if none is found, default layer is assigned
            let layer = this.defaultLayer;
            if (itemData.attributes['layer'] && sdk_sdtf_primitives_1.SdtfPrimitiveTypeGuard.isStringType(itemData.attributes['layer'].typeHint)) {
                const layerAttributes = itemData.attributes['layer'];
                layer = __classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f")[layerAttributes.value];
            }
            // early out, layer is not enabled
            if (layer.enabled === false) {
                const mat = __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f").clone();
                mat.opacity = 0;
                return {
                    matrix: gl_matrix_1.mat4.create(),
                    material: mat
                };
            }
            if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_attributes, "f").length === 0) {
                // no attributes are specified, we go into layer visualization mode
                const material = new viewer_1.MaterialUnlitData({
                    opacity: layer.opacity,
                    color: __classPrivateFieldGet(this, _AttributeVisualizationEngine_converter, "f").toColor(layer.color)
                });
                return {
                    matrix: gl_matrix_1.mat4.create(),
                    material
                };
            }
            else {
                // attributes are specified, we go into attribute visualization mode
                const material = new viewer_1.MaterialUnlitData();
                for (let i = 0; i < __classPrivateFieldGet(this, _AttributeVisualizationEngine_attributes, "f").length; i++) {
                    const a = __classPrivateFieldGet(this, _AttributeVisualizationEngine_attributes, "f")[i];
                    if (itemData.attributes[a.key] && itemData.attributes[a.key].typeHint === a.type) {
                        const itemDataAttribute = itemData.attributes[a.key];
                        const itemDataAttributeOverview = overview[a.key].filter(o => o.typeHint === a.type)[0];
                        switch (true) {
                            case sdk_sdtf_primitives_1.SdtfPrimitiveTypeGuard.isColorType(a.type):
                                material.color = __classPrivateFieldGet(this, _AttributeVisualizationEngine_converter, "f").toColor('rgb(' + itemDataAttribute.value + ')');
                                material.opacity *= layer.opacity;
                                return {
                                    matrix: gl_matrix_1.mat4.create(),
                                    material
                                };
                            case sdk_sdtf_primitives_1.SdtfPrimitiveTypeGuard.isNumberType(a.type):
                                const numberAttribute = a;
                                const numberVisualizationData = viewer_1.SDTFAttributeVisualization.numberVisualization(itemDataAttribute.value, (numberAttribute.min !== undefined ? numberAttribute.min : itemDataAttributeOverview.min), (numberAttribute.max !== undefined ? numberAttribute.max : itemDataAttributeOverview.max), numberAttribute.visualization, __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f"));
                                numberVisualizationData.material.opacity *= layer.opacity;
                                return numberVisualizationData;
                            case sdk_sdtf_primitives_1.SdtfPrimitiveTypeGuard.isStringType(a.type):
                                const stringAttribute = a;
                                const stringVisualizationData = viewer_1.SDTFAttributeVisualization.stringVisualization(itemDataAttribute.value, stringAttribute.values || itemDataAttributeOverview.values, stringAttribute.visualization, __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f"));
                                stringVisualizationData.material.opacity *= layer.opacity;
                                return stringVisualizationData;
                            default:
                                const defaultAttribute = a;
                                material.color = __classPrivateFieldGet(this, _AttributeVisualizationEngine_converter, "f").toColor(defaultAttribute.color);
                                material.opacity *= layer.opacity;
                                return {
                                    matrix: gl_matrix_1.mat4.create(),
                                    material
                                };
                        }
                    }
                }
                // no attributes were found, return the default material adjusted by the layer opacity
                const mat = __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f").clone();
                mat.opacity *= layer.opacity;
                return {
                    matrix: gl_matrix_1.mat4.create(),
                    material: mat
                };
            }
        };
        __classPrivateFieldGet(this, _AttributeVisualizationEngine_api, "f").sceneTree.root.updateVersion();
        __classPrivateFieldGet(this, _AttributeVisualizationEngine_api, "f").update();
    }
    createLayers() {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_layers, {}, "f");
        if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_overview, "f")['layer']) {
            const layerStringAttributeOverview = __classPrivateFieldGet(this, _AttributeVisualizationEngine_overview, "f")['layer'].find(a => a.typeHint === 'string');
            if (layerStringAttributeOverview && layerStringAttributeOverview.values) {
                for (let i = 0; i < layerStringAttributeOverview.values.length; i++) {
                    __classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f")[layerStringAttributeOverview.values[i]] = {
                        enabled: true,
                        opacity: 1,
                        color: this.defaultMaterial.color
                    };
                }
            }
        }
    }
}
exports.AttributeVisualizationEngine = AttributeVisualizationEngine;
_AttributeVisualizationEngine_api = new WeakMap(), _AttributeVisualizationEngine_converter = new WeakMap(), _AttributeVisualizationEngine_uuidGenerator = new WeakMap(), _AttributeVisualizationEngine_viewer = new WeakMap(), _AttributeVisualizationEngine_attributes = new WeakMap(), _AttributeVisualizationEngine_defaultMaterial = new WeakMap(), _AttributeVisualizationEngine_defaultLayer = new WeakMap(), _AttributeVisualizationEngine_layers = new WeakMap(), _AttributeVisualizationEngine_overview = new WeakMap(), _AttributeVisualizationEngine_listeners = new WeakMap();
//# sourceMappingURL=AttributeVisualizationEngine.js.map